import { IUserModel } from 'models/user.model'
import api from '../..'

export const editSupervisors = (userId: number, supervisorIds: string[]) => {
  return api
    .post<IUserModel[]>(`administration/users/${userId}/supervisors`, {
      user: { id: userId, supervisorIds },
    })
    .then(({ data }) => data)
}
